
export default function ChargingTimeTableModule(element) {

    let toDelete = [];
    element.querySelectorAll('tr').forEach(tableRow => {
        tableRow.querySelectorAll('td').forEach(tableCell => {
            if (tableCell.innerText.trim() === '-h') {
                toDelete.push(tableRow);
            }
        });
    });

    toDelete.forEach(tableRow => {
        tableRow.remove();
    });
   
    return this;
}
